import React, { useState, useEffect, useRef } from 'react';
import '../css/Veritems.css';
import { FaTimes } from 'react-icons/fa';
import axios from 'axios';
import noImageIcon from '../images/no-image-icon.svg';

const Showitems = ({ onClose, pedido, handleShowCheckList }) => {
    const [items, setItems] = useState([]);
    const [expandedItems, setExpandedItems] = useState({});
    const modalRef = useRef();

    useEffect(() => {
        const fetchItems = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/get-producto-id-pedido/${pedido.id}`);
                setItems(response.data);
            } catch (error) {
                console.error('Error fetching items:', error);
            }
        };

        fetchItems();
    }, [pedido]);

    const getImageUrl = (imagePath) => {
        if (!imagePath) return noImageIcon;
        return `${process.env.REACT_APP_API_URL}${imagePath}`;
    };

    const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            onClose();
        }
    };

    return (
        <div className='overlayShowItems' onClick={handleClickOutside}>
            <div className="SI-container" ref={modalRef}>
                <div className="table-container">
                    <div className="table-header">
                        <h2 className='SI-h2'>Ítems</h2>
                        <button className="toggle-button" onClick={onClose}>
                            <FaTimes />
                        </button>
                    </div>
                    <div className="table-body">
                        <table className="bg-white text-center item-table">
                            <thead>
                                <tr>
               
                                </tr>
                            </thead>
                            <tbody>
                                {items.map(item => {
                                    const imageUrl = item.image ? getImageUrl(item.image.image) : noImageIcon;
                                    const expanded = expandedItems[item.id] || false;
                                    const handleExpandClick = () => {
                                        setExpandedItems(prev => ({
                                            ...prev,
                                            [item.id]: !expanded
                                        }));
                                    };
                                    return (
                                        <tr key={item.id} className="item-row">
                                            <td><img src={imageUrl} alt={item.equipo} className="item-image" /></td>
                                            <td>
                                                <div
                                                    className={`item-details${expanded ? ' expanded' : ''}`}
                                                    style={{ cursor: 'pointer', borderRadius: '8px', padding: '8px', background: '#f7f7f7', boxShadow: expanded ? '0 2px 8px rgba(0,0,0,0.08)' : 'none' }}
                                                    onClick={handleExpandClick}
                                                >
                                                    <p style={{ fontWeight: 'bold', marginBottom: '4px' }}>Nombre: <span style={{ color: '#2c3e50' }}>{item.equipo ? item.equipo : "No Disponible"}</span></p>
                                                    <p style={{ fontWeight: 'bold', marginBottom: expanded ? '8px' : '0' }}>Marca: <span style={{ color: '#2c3e50' }}>{item.marca ? item.marca : "No Disponible"}</span></p>
                                                    {expanded && (
                                                        <div className="item-extra-details" style={{ marginTop: '8px', fontSize: '0.97em', color: '#555' }}>
                                                            <p>Descripción: {item.descripcion ? item.descripcion : "No Disponible"}</p>
                                                            <p>Estado: {item.estado ? item.estado : "No Disponible"}</p>
                                                            <p>Sección: {item.seccion ? item.seccion : "No Disponible"}</p>
                                                            <p>Fecha Vencimiento: {item.fechaVencimiento ? item.fechaVencimiento : "No Disponible"}</p>
                                                            <p>Observación: {item.observacion ? item.observacion : "No Disponible"}</p>
                                                            <p>Proveedor: {item.proveedor ? item.proveedor : "No Disponible"}</p>
                                                        </div>
                                                    )}
                                                    <div style={{ textAlign: 'right', marginTop: '4px' }}>
                                                        <span style={{ fontSize: '0.9em', color: '#2980b9' }}>{expanded ? '▲ Ocultar detalles' : '▼ Ver más detalles'}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='show-item-cantidad'>
                                                    <span className="unit-text">{item.cantidad}</span>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className="table-footer">
                        <button className="show-checklist-button" onClick={() => handleShowCheckList(pedido)}>
                            Mostrar Checklist
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Showitems;